"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EarthRadiusMeters = 6371e3;
var EarthRadiusMiles = 3958.756;
var Mile2Meter = 1609.34;
/**
 * Calculate the distance of two locations
 * @param inMiles the default value is true
 * @return the value in mile if inMiles is true, otherwise in meters
 */

function geoDistance(lat1, lon1, lat2, lon2) {
  var inMiles = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var φ1 = degrees2Radians(lat1);
  var φ2 = degrees2Radians(lat2);
  var Δφ = degrees2Radians(lat2 - lat1);
  var Δλ = degrees2Radians(lon2 - lon1);
  var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2);
  a += Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  if (inMiles) {
    return EarthRadiusMiles * c;
  } else {
    return EarthRadiusMeters * c;
  }
}

exports.geoDistance = geoDistance;

function degrees2Radians(degrees) {
  return degrees * (Math.PI / 180);
}

exports.degrees2Radians = degrees2Radians;

function meter2Radians(meter) {
  return meter / EarthRadiusMeters;
}

exports.meter2Radians = meter2Radians;

function mile2Radians(mile) {
  return mile / EarthRadiusMiles;
}

exports.mile2Radians = mile2Radians;

function mile2Meter(mile) {
  return mile * Mile2Meter;
}

exports.mile2Meter = mile2Meter;

function boundsToPolygon(bounds) {
  return {
    type: "Polygon",
    coordinates: [[[bounds[0][0], bounds[0][1]], [bounds[1][0], bounds[0][1]], [bounds[1][0], bounds[1][1]], [bounds[0][0], bounds[1][1]], [bounds[0][0], bounds[0][1]]]]
  };
}

exports.boundsToPolygon = boundsToPolygon;

function printBounds(bounds) {
  // for debug with https://www.keene.edu/campus/maps/tool/
  console.log("".concat(bounds[0][0], ", ").concat(bounds[0][1], "\n").concat(bounds[1][0], ",").concat(bounds[0][1], "\n").concat(bounds[1][0], ", ").concat(bounds[1][1], "\n").concat(bounds[0][0], ", ").concat(bounds[1][1]));
}

exports.printBounds = printBounds;